import React from "react";
import point from "./../../../../../Images/point.png";

const TrendyHairHighlightAshBrown = () => {
  return (
    <div className="blogWhat-content">
      <h5>8. Ash Brown & Cool-Toned Highlights 🌫️</h5>
      <p>
        For those who prefer a sleek, cool-toned look, ash brown highlights are
        a must-try. These hair highlights for women are subtle but
        sophisticated, creating a modern and effortlessly chic style.
      </p>
      <ul>
        <h4>Why It’s Trending:</h4>
        <li>
          <span>
            <img src={point} alt="point" />
            Provides a sleek, polished look{" "}
          </span>
        </li>
        <li>
          <span>
            <img src={point} alt="point" />  Ideal for those who prefer neutral
            tones
          </span>
         
        </li>
        <li>
          <span>
            <img src={point} alt="point" />	Works best on straight or wavy hair
          </span>
        </li>
      </ul>
    </div>
  );
};

export default TrendyHairHighlightAshBrown;
